// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-timeline .p-timeline-event-opposite{display:none}p{font-size:18px;color:grey;width:1000px}", ""]);
// Exports
module.exports = exports;
